import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";

export default () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  return isDesktop;
};
